(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('rationale', {
                parent: 'entity',
                url: '/rationale',
                data: {
                    authorities: [],
                    pageTitle: 'Rationale'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/relational/list/relational.html',
                        controller: 'RelationalController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_RATIONALE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_RATIONALE, access);
                }]
            });
    }
})();
